import { render, staticRenderFns } from "./AcknowledgeMessages.vue?vue&type=template&id=d2cf35ec&"
import script from "./AcknowledgeMessages.vue?vue&type=script&lang=js&"
export * from "./AcknowledgeMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports